import type { ReactNode } from 'react'

import { useEffect, useRef } from 'react'
import { mountEmbed } from '@/components/generals/code-embed'

const MOUNTED = new WeakSet<Element>()

// Renders CMS rich text inside one .rich-text wrapper. The server sends the full
// text; embed blocks are mounted in the browser only.
export default function RichText({ html, className }: { html?: string | null, className?: string }): ReactNode {
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        for (const host of Array.from(ref.current?.querySelectorAll<HTMLElement>(':scope > div[data-embed]') ?? [])) {
            if (MOUNTED.has(host) || host.childElementCount > 0) continue

            MOUNTED.add(host)
            mountEmbed(host, host.getAttribute('data-embed') ?? '')
        }
    }, [html])

    return <div ref={ref} className={className ? 'rich-text ' + className : 'rich-text'} dangerouslySetInnerHTML={{ __html: html ?? '' }} />
}
